// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
    outline: solid 1px red;
} */

.support-comments-user{
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    width:2rem;
    height: 2rem;
    background-color: rgb(236, 236, 254);
    color:rgb(64, 64, 242);
}
.support-each-comment-user-icon-container,.support-each-comment-reply-icon-container{
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width:-moz-fit-content;
    width:fit-content;
    height: 100%;
    align-self: flex-start;
    /* padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-right: 1rem;; */
}
.support-each-comments-reply{
    display: flex;
    flex-direction: column;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    width:2rem;
    height: 2rem;
    background-color: rgb(218, 243, 240);
    color:rgb(138, 246, 225);
    border: 2px solid rgb(138, 246, 225);
}
.support-each-comments-user{
    display: flex;
    flex-direction: column;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    align-self:flex-start;
    width:2rem;
    height: 2rem;
    background-color: rgb(217, 217, 252);
    color:rgb(64, 64, 242);
    border: 2px solid rgb(202, 202, 255);
}
.support-margin-container{

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items:center;
        height:100%;
        padding: 1.5rem;
        overflow: scroll;
        /* height:400px; */
        /* flex-grow: 1; */
}
.support-comments-content{
    display: flex;
    /* flex-direction: column-reverse; */
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    width:100%;
    flex-grow: 1; /* Fill available space */
    /* overflow-y:scroll; */
    
}
.each-comment-user,.each-comment-reply{
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom:1rem;
}
.each-comment-reply{
    justify-content:flex-start;
}
.each-comment-user{
    justify-content:flex-end;
}
.comments-user-comment,.comments-reply-comment{
    display: flex;
    align-items: center;
    /* width: 100%; */
    gap:0.5rem;
    /* position:relative; */
}
.multi-line{
    display: flex;
    flex-direction: column;
    gap:0.5rem;
}
.comments-reply-comment{
    justify-content: flex-start;
    /* left:0%; */
}
.comments-user-comment{
    justify-content: flex-end;
    flex-direction: row-reverse;
    /* right:0%; */
}
.each-comment-content,.each-comment-reply-content{
    display: flex;
    flex-direction: column;
    /*  //initally flex-end */
    align-items: flex-start;
    /* text-align: left; */
    overflow-y:scroll;
    height:100%;
    padding:0.5rem;
    
}
.each-comment-reply-content{
    background-color: rgb(194, 240, 231);
    border-radius: 1rem;
    border-top-left-radius: 0px;
    /* width:100%; */
    width:-moz-fit-content;
    width:fit-content;
}
.each-comment-content{
    background-color: rgb(217, 217, 252);
    border-radius: 1rem;
    border-top-right-radius: 0px;
    /* Added for p tag commments align */
    width:-moz-fit-content;
    width:fit-content;
    align-items: flex-end;
    align-self: flex-end;
}
.comment{
    margin-bottom:0px;
    /* text-align:justify; */
}
.file-preview-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:100%;
    height:auto;
}
.preview-image{
    width: 100%;
    height:auto;
    border-radius:0.5rem;
}
.preview-filename {
    width:8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
.comments-footer-container{
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: flex-end;
    width:100%;
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
}
.comments-footer{
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: flex-end;
    width:100%;
    padding:0.5rem;
    padding-left:1.5rem;
    padding-right:1.5rem; 
    font-family: "PlusJakartaSans";
    box-shadow: 1px 2px 9px rgb(219, 219, 219);
}
.support-comments-input{
    outline:none;
    width:50%;
    border:none;
}

.upload-files-container{
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
}
.uploaded-file-container{
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    height:5rem;
    border:1px solid rgb(197, 197, 251);
    gap:0.5rem;
    justify-content: flex-start;
    padding-left:0.5rem;
    padding-right:0.5rem;
}
.uploaded-image{
    display: flex;
    align-items: center;
    justify-content: center;
    width:4rem;
    height:4rem;
    border:1px solid rgb(197, 197, 251);    
    position:relative;

}
.upload-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width:4rem;
    height:4rem;
    border:1px solid rgb(223, 227, 232);   
    margin-bottom:0px; 
  }
.uploaded-image-close{
    width:0.5rem;
    height:0.5rem;
    top:0.0625%;
    right:15%;
    position:absolute;
    font-weight: 600;
}
  
  .square-box {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  
  .plus-icon {
    font-size: 36px; /* Adjust size as needed */
    color: rgb(145, 158, 171); /* Adjust color as needed */
  }
input::file-selector-button {
    font-weight: bold;
    color: rgb(145, 158, 171);
    padding: 0.5em;
    border: thin solid grey;
    border-radius: 3px;
  }
.support-footer-btn-container{
    display:flex;
    width: 100%;
    /* height: fit-content; */
    background-color: white;
    border-radius:0.25rem; 
    align-items: center;
    justify-content: space-between;
    gap:1rem;
 }`, "",{"version":3,"sources":["webpack://./src/pages/support/Comments/Comments.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAiB;IAAjB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB;;0BAEsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,wBAAwB;IACxB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,sBAAsB;IACtB,oCAAoC;AACxC;AACA;;QAEQ,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;AAC1B;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,UAAU;IACV,YAAY,EAAE,yBAAyB;IACvC,uBAAuB;;AAE3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,cAAc;;AAElB;AACA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;IAChB,sBAAiB;IAAjB,iBAAiB;AACrB;AACA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,4BAA4B;IAC5B,oCAAoC;IACpC,sBAAiB;IAAjB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,iBAAiB;;AAErB;AACA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,mCAAmC;IACnC,iBAAiB;EACnB;AACF;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;EAEE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe,EAAE,0BAA0B;IAC3C,yBAAyB,EAAE,2BAA2B;EACxD;AACF;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;EACpB;AACF;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;CACX","sourcesContent":["/* * {\r\n    outline: solid 1px red;\r\n} */\r\n\r\n.support-comments-user{\r\n    display: flex;\r\n    border-radius: 50%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:2rem;\r\n    height: 2rem;\r\n    background-color: rgb(236, 236, 254);\r\n    color:rgb(64, 64, 242);\r\n}\r\n.support-each-comment-user-icon-container,.support-each-comment-reply-icon-container{\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    width:fit-content;\r\n    height: 100%;\r\n    align-self: flex-start;\r\n    /* padding-left: 0.5rem;\r\n    padding-right: 0.5rem;\r\n    margin-right: 1rem;; */\r\n}\r\n.support-each-comments-reply{\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-radius: 50%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:2rem;\r\n    height: 2rem;\r\n    background-color: rgb(218, 243, 240);\r\n    color:rgb(138, 246, 225);\r\n    border: 2px solid rgb(138, 246, 225);\r\n}\r\n.support-each-comments-user{\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-radius: 50%;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-self:flex-start;\r\n    width:2rem;\r\n    height: 2rem;\r\n    background-color: rgb(217, 217, 252);\r\n    color:rgb(64, 64, 242);\r\n    border: 2px solid rgb(202, 202, 255);\r\n}\r\n.support-margin-container{\r\n\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n        align-items:center;\r\n        height:100%;\r\n        padding: 1.5rem;\r\n        overflow: scroll;\r\n        /* height:400px; */\r\n        /* flex-grow: 1; */\r\n}\r\n.support-comments-content{\r\n    display: flex;\r\n    /* flex-direction: column-reverse; */\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    justify-content: flex-end;\r\n    width:100%;\r\n    flex-grow: 1; /* Fill available space */\r\n    /* overflow-y:scroll; */\r\n    \r\n}\r\n.each-comment-user,.each-comment-reply{\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-bottom:1rem;\r\n}\r\n.each-comment-reply{\r\n    justify-content:flex-start;\r\n}\r\n.each-comment-user{\r\n    justify-content:flex-end;\r\n}\r\n.comments-user-comment,.comments-reply-comment{\r\n    display: flex;\r\n    align-items: center;\r\n    /* width: 100%; */\r\n    gap:0.5rem;\r\n    /* position:relative; */\r\n}\r\n.multi-line{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:0.5rem;\r\n}\r\n.comments-reply-comment{\r\n    justify-content: flex-start;\r\n    /* left:0%; */\r\n}\r\n.comments-user-comment{\r\n    justify-content: flex-end;\r\n    flex-direction: row-reverse;\r\n    /* right:0%; */\r\n}\r\n.each-comment-content,.each-comment-reply-content{\r\n    display: flex;\r\n    flex-direction: column;\r\n    /*  //initally flex-end */\r\n    align-items: flex-start;\r\n    /* text-align: left; */\r\n    overflow-y:scroll;\r\n    height:100%;\r\n    padding:0.5rem;\r\n    \r\n}\r\n.each-comment-reply-content{\r\n    background-color: rgb(194, 240, 231);\r\n    border-radius: 1rem;\r\n    border-top-left-radius: 0px;\r\n    /* width:100%; */\r\n    width:fit-content;\r\n}\r\n.each-comment-content{\r\n    background-color: rgb(217, 217, 252);\r\n    border-radius: 1rem;\r\n    border-top-right-radius: 0px;\r\n    /* Added for p tag commments align */\r\n    width:fit-content;\r\n    align-items: flex-end;\r\n    align-self: flex-end;\r\n}\r\n.comment{\r\n    margin-bottom:0px;\r\n    /* text-align:justify; */\r\n}\r\n.file-preview-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width:100%;\r\n    height:auto;\r\n}\r\n.preview-image{\r\n    width: 100%;\r\n    height:auto;\r\n    border-radius:0.5rem;\r\n}\r\n.preview-filename {\r\n    width:8rem;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    font-size: 14px;\r\n  }\r\n.comments-footer-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items:center;\r\n    justify-content: flex-end;\r\n    width:100%;\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n}\r\n.comments-footer{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items:center;\r\n    justify-content: flex-end;\r\n    width:100%;\r\n    padding:0.5rem;\r\n    padding-left:1.5rem;\r\n    padding-right:1.5rem; \r\n    font-family: \"PlusJakartaSans\";\r\n    box-shadow: 1px 2px 9px rgb(219, 219, 219);\r\n}\r\n.support-comments-input{\r\n    outline:none;\r\n    width:50%;\r\n    border:none;\r\n}\r\n\r\n.upload-files-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:100%;\r\n}\r\n.uploaded-file-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:100%;\r\n    height:5rem;\r\n    border:1px solid rgb(197, 197, 251);\r\n    gap:0.5rem;\r\n    justify-content: flex-start;\r\n    padding-left:0.5rem;\r\n    padding-right:0.5rem;\r\n}\r\n.uploaded-image{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:4rem;\r\n    height:4rem;\r\n    border:1px solid rgb(197, 197, 251);    \r\n    position:relative;\r\n\r\n}\r\n.upload-button {\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width:4rem;\r\n    height:4rem;\r\n    border:1px solid rgb(223, 227, 232);   \r\n    margin-bottom:0px; \r\n  }\r\n.uploaded-image-close{\r\n    width:0.5rem;\r\n    height:0.5rem;\r\n    top:0.0625%;\r\n    right:15%;\r\n    position:absolute;\r\n    font-weight: 600;\r\n}\r\n  \r\n  .square-box {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n  \r\n  .plus-icon {\r\n    font-size: 36px; /* Adjust size as needed */\r\n    color: rgb(145, 158, 171); /* Adjust color as needed */\r\n  }\r\ninput::file-selector-button {\r\n    font-weight: bold;\r\n    color: rgb(145, 158, 171);\r\n    padding: 0.5em;\r\n    border: thin solid grey;\r\n    border-radius: 3px;\r\n  }\r\n.support-footer-btn-container{\r\n    display:flex;\r\n    width: 100%;\r\n    /* height: fit-content; */\r\n    background-color: white;\r\n    border-radius:0.25rem; \r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap:1rem;\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
